import { render, staticRenderFns } from "./PolicyConfigV2.vue?vue&type=template&id=a2e1cc9a&scoped=true"
import script from "./PolicyConfigV2.vue?vue&type=script&lang=ts"
export * from "./PolicyConfigV2.vue?vue&type=script&lang=ts"
import style0 from "./PolicyConfigV2.vue?vue&type=style&index=0&id=a2e1cc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e1cc9a",
  null
  
)

export default component.exports